import ReactDOM from 'react-dom/client';
//import React from 'react';
import { Provider } from 'react-redux'
import { store, pStore } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';

import App from './App';

import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('formBlock') as HTMLElement
);


/*
  disabilito lo StrictMode -- duplica i rendering e le fetch
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={pStore}>
          <App />
        </PersistGate>
      </Provider>
    </React.StrictMode>
  ); 
 */
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={pStore}>
      <App />
    </PersistGate>
  </Provider>
);
